
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/catalogo/[id]",
      function () {
        return require("private-next-pages/catalogo/[id]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/catalogo/[id]"])
      });
    }
  